export default __webpack_public_path__ + "static/img/img_hydw2.167b08c.png";